import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import { Input } from "src/components";
import { useAlert, useRefetchBookings, useRefetchGroup } from "src/hooks";
import { createTeeshotAxiosInstance } from "src/http";
import AlertModal from "src/components/YearBooking/components/common/AlertModal";
import groupJoin from "../assets/images/groupjoin.png";

const testCode = (code: string) => {
  const regex = /^[A-Z]{3}\d{4}$/;
  return regex.test(code);
};

export default function GroupJoin() {
  const { onChange, value } = Input.hooks.useInput();
  const alert = useAlert();
  const navigate = useNavigate();
  const refetchBookings = useRefetchBookings();
  const refetchGroup = useRefetchGroup();

  // AlertModal 상태 관리
  const [showEmptyCodeModal, setShowEmptyCodeModal] = useState(false);
  const [showInvalidCodeModal, setShowInvalidCodeModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <StyledContainer>
      <ContentArea>
        <div className="d-flex fd-c gap-2 mt-6 mb-2 ">
          <div className="div1">단체 총무님에게 초대장을 받으셨나요?</div>
          <div className="div2">
            초대장의 단체코드를 입력하시면 해당 단체에 참여하실 수 있습니다.
          </div>
        </div>
        <div className="d-flex fd-c gap-10 mt-2 mb-2">
          {/* <Button
            $round
            $colorTheme="green"
            className="as-e"
            onClick={() => {
              (async () => {
                const copied = await getClipboardData();
                if (!copied) {
                  alert("복사된 값이없습니다. 초대장을 보고 직접 코드를 입력해주세요.");
                  return;
                }
                if (!testCode(copied as string)) {
                  alert(
                    "복사된 코드형태가 올바르지 않습니다. 초대장을 보고 직접 코드를 입력해주세요."
                  );
                  return;
                }
                resetValue(copied);
              })();
            }}
          >
            단체코드 자동입력
          </Button> */}
          <Input
            hasValue={!!value}
            attr={{ onChange, value, placeholder: "초대장의 7자리 코드를 입력하세요" }}
          />

          <ImageWrapper>
            <img src={groupJoin} alt="groupJoin" />
          </ImageWrapper>
        </div>
      </ContentArea>

      <FixedBottomContainer>
        <FixedBottomButton
          onClick={async () => {
            if (!value) {
              setShowEmptyCodeModal(true);
              return;
            }
            if (!testCode(value as string)) {
              setShowInvalidCodeModal(true);
              return;
            }
            try {
              const res = await createTeeshotAxiosInstance().post(
                `/yearBooking/group/joinWithTeeshotId?groupCode=${value}`
              );
              if (!res.data.success) {
                throw new Error(res.data.message);
              }

              if (res.data.success) {
                alert({
                  content: "성공적으로 단체에 참여했습니다.",
                  onClose: async () => {
                    await Promise.all([refetchGroup(), refetchBookings()]);

                    navigate("/year-booking");
                    // window.location.reload();
                  },
                });
              }
            } catch (e: any) {
              setErrorMessage(e.message || "오류가 발생했습니다.");
              setShowErrorModal(true);
            }
          }}
        >
          연 단체 참여하기
        </FixedBottomButton>
      </FixedBottomContainer>

      {/* AlertModals */}
      {showEmptyCodeModal && (
        <AlertModal
          onClose={() => setShowEmptyCodeModal(false)}
          title="알림"
          subtitle="그룹코드를 입력해주세요."
          lines={[]}
          confirmText="확인"
          onConfirm={() => setShowEmptyCodeModal(false)}
        />
      )}

      {showInvalidCodeModal && (
        <AlertModal
          onClose={() => setShowInvalidCodeModal(false)}
          title="알림"
          subtitle="그룹코드 형태가 올바르지 않습니다."
          lines={[]}
          confirmText="확인"
          onConfirm={() => setShowInvalidCodeModal(false)}
        />
      )}

      {showErrorModal && (
        <AlertModal
          onClose={() => setShowErrorModal(false)}
          title="알림"
          subtitle={errorMessage || "오류"}
          lines={[]}
          confirmText="확인"
          onConfirm={() => setShowErrorModal(false)}
        />
      )}
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const ContentArea = styled.div`
  width: 90%;
  margin: 0 auto;
  padding-bottom: 120px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;

  img {
    max-width: 100%;
    height: auto;
  }
`;

const FixedBottomContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding: 28px 16px;
  background: linear-gradient(0deg, #fdfdfd 76.92%, rgba(253, 253, 253, 0) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const FixedBottomButton = styled.button`
  width: 100%;
  height: 60px;
  border: none;
  border-radius: 10px;
  background: var(--teeshot-green, #004b49);
  color: white;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;

  &:hover {
    background: #003a38;
  }

  &:active {
    background: #002927;
  }
`;
